import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { calendarEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-calendar/entrypoint.tsx';

export const calendarPageEntryPoint = createPageEntryPoint({
	main: calendarEntryPoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
